import React from 'react'

import Reflux from 'reflux-react-16'
import _ from 'lodash'

import {Colors, H3, Tabs, Tab, P, Card, Row} from '../../../../components/UI/index.js'
import EmailPreview from '../../../../components/settings/EmailPreview.js'
import {formSpacing, Editor, FormStack, Input, Toggle} from '../../../../components/UI/forms/index.js'

import trackTraceEmailTemplate from '../../../../../server/functions/mail/templates/trackTraceEmailTemplate.js'
import cancelEmailTemplate from '../../../../../server/functions/mail/templates/cancelEmailTemplate.js'
import {defaultDeliveredEmail} from '../../../../../server/models/resellerDefaults/defaultDeliveredEmail.js'
import t from 'src/helpers/Languages.js'

const exampleAddress = {
    name: 'John Doe',
    attention: '',
    street: 'Straatnaam',
    nr: '123',
    addition: '',
    street2: '',
    postalCode: '1234 AB',
    city: 'Plaats',
    country: 'NL'
}

// Per tab: where the mail is stored, its switch and what it can contain
const views = {
    confirmed: {path: 'parcels.trackTrace', toggle: 'sendTTMails', toggleLabel: 'sendConfirmedEmail', comment: 'parcelMailCommentConfirmed', tags: ['trackTraceCode', 'trackTraceLink']},
    delivered: {path: 'parcels.deliveredEmail', toggle: 'sendDeliveredEmails', toggleLabel: 'sendDeliveredEmail', comment: 'parcelMailCommentDelivered', tags: ['trackTraceCode', 'trackTraceLink']},
    cancelEmail: {path: 'parcels.cancelEmail', toggle: 'sendCancelEmails', toggleLabel: 'sendCancelledEmail', comment: 'parcelMailCommentCancelled', tags: ['barcode']}
}

export default class CustomerTrackTraceEmail extends Reflux.Component {
    constructor(props) {
        super(props)

        this.state = {
            view: 'confirmed'
        }
    }

    onChangeChecked(path, event) {
        const reseller = {...this.props.reseller}

        _.set(reseller.settings, path, event.target.checked)

        this.props.onChange(reseller, path)
    }

    onChangeValue(path, event) {
        const reseller = {...this.props.reseller}

        _.set(reseller.settings, path, event.target.value)

        this.props.onChange(reseller)
    }

    onSaveValue(path, event) {
        const reseller = {...this.props.reseller}

        if (event) {
            _.set(reseller.settings, path, event.target.value)
        }

        this.props.onChange(reseller, path)
    }

    // The delivered mail is new, accounts from before it get the defaults until they change it
    emailSettings(view) {
        const settings = _.get(this.props.reseller.settings, views[view].path)
        return view === 'delivered' ? {...defaultDeliveredEmail(), ...settings} : settings
    }

    renderEmail(view) {
        const {reseller} = this.props
        const {path, toggle, toggleLabel, comment, tags} = views[view]
        const email = this.emailSettings(view)

        return (
            <>
                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Toggle
                        label={t(toggleLabel)}
                        checked={email[toggle]}
                        onChange={this.onChangeChecked.bind(this, `${path}.${toggle}`)}
                    />

                    <Input
                        label={t('mailSenderName')}
                        placeholder={reseller.settings?.accountName || reseller.name}
                        value={email.senderName}
                        onChange={this.onChangeValue.bind(this, `${path}.senderName`)}
                        onBlur={this.onSaveValue.bind(this, `${path}.senderName`)}
                    />

                    <Input
                        label={t('mailSenderEmail')}
                        placeholder={reseller.settings.companyAddress.email || (reseller.settings.useOwnSMTP && reseller.settings.smtpUser) || 'noreply@veloyd.nl'}
                        value={email.replyToEmail}
                        onChange={this.onChangeValue.bind(this, `${path}.replyToEmail`)}
                        onBlur={this.onSaveValue.bind(this, `${path}.replyToEmail`)}
                    />
                </FormStack>

                <br />
                <FormStack>
                    <Editor
                        label={t('mailSubject')}
                        as='input'
                        tags={['bedrijfsnaam', 'klant', 'naam', 'referentie', 'vervoerder', ...tags.filter((tag) => tag !== 'trackTraceLink')]}
                        value={email.emailSubject}
                        onChange={this.onSaveValue.bind(this, `${path}.emailSubject`)}
                    />

                    <Editor
                        label={t('message')}
                        tags={['bedrijfsnaam', 'klant', 'naam', 'referentie', 'vervoerder', ...tags]}
                        value={email.emailBody}
                        onChange={this.onSaveValue.bind(this, `${path}.emailBody`)}
                        comment={t(comment)}
                    />
                </FormStack>
            </>
        )
    }

    render() {
        const {reseller} = this.props
        const {view} = this.state

        const email = this.emailSettings(view)

        return (
            <Row style={{gap: 24}}>
                <Card shadow style={{width: 600, padding: 24, height: 'fit-content'}}>
                    <H3 style={{marginBottom: 36}}>{t('parcelMailTitle')}</H3>

                    <P>{t('parcelMailIntro')}</P>

                    <Tabs style={{marginBottom: 30, marginTop: 24}} value={view} onChange={(event) => this.setState({view: event.target.value})}>
                        <Tab value='confirmed'>{t('parcelMailTabConfirmed')}</Tab>
                        {reseller.isShop && <Tab value='delivered'>{t('delivered')}</Tab>}
                        <Tab value='cancelEmail'>{t('parcelMailTabCancelled')}</Tab>
                    </Tabs>

                    {this.renderEmail(view)}
                </Card>

                <div style={{width: 650}}>
                    {(view === 'confirmed' || view === 'delivered') &&
                        <EmailPreview
                            type='trackTrace'
                            action={view}
                            html={trackTraceEmailTemplate({
                                logo: reseller.settings.logo || '/images/logoPlaceholder.png',
                                message: email.emailBody?.replace(/\n/g, '<br/>') || '',
                                color: reseller.settings.color || Colors.brandColor,
                                parcel: {
                                    senderAddress: {
                                        name: t('customer')
                                    },
                                    trackTrace: 'VEL73BF282DF2',
                                    reference: '831012'
                                },
                                addressHeader: t('deliveryAddress'),
                                address: exampleAddress
                            }, window.location.origin)}
                        />
                    }

                    {view === 'cancelEmail' &&
                        <EmailPreview
                            type='cancelEmail'
                            html={cancelEmailTemplate({
                                logo: reseller.settings.logo || '/images/logoPlaceholder.png',
                                message: email.emailBody?.replace(/\n/g, '<br/>') || '',
                                color: reseller.settings.color || Colors.brandColor,
                                parcel: {
                                    senderAddress: {
                                        name: t('customer')
                                    },
                                    address: exampleAddress,
                                    trackTrace: 'VEL73BF282DF2',
                                    reference: '831012'
                                }
                            }, window.location.origin)}
                        />
                    }
                </div>
            </Row>
        )
    }
}
